import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import server from "../../../functions/server";
import CryptoJS from "crypto-js";

const ImpersonateModal = ({ open, onClose }) => {
  const [clientId, setClientId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleImpersonate = async () => {
    if (!clientId) {
      setError("Por favor, insira um CPF/CNPJ válido");
      return;
    }

    setLoading(true);
    setError("");

    try {
      // Store the original admin user (MedSystems CNPJ) in localStorage
      const adminCnpj = "05273422000154";
      const encryptedAdmin = CryptoJS.AES.encrypt(adminCnpj, "MedSys@341").toString();
      localStorage.setItem("admin", encryptedAdmin);

      // Encrypt and store the impersonated user
      const encryptedUser = CryptoJS.AES.encrypt(
        clientId.replace(/\D/g, ""),
        "MedSys@341",
      ).toString();
      localStorage.setItem("user", encryptedUser);

      // Reload the page to reflect the new user
      window.location.reload();
    } catch (err) {
      setError("Erro ao impersonar cliente");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Visualizar como Cliente</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="CPF/CNPJ do Cliente"
          type="text"
          fullWidth
          value={clientId}
          onChange={(e) => setClientId(e.target.value)}
          error={!!error}
          helperText={error}
          disabled={loading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button onClick={handleImpersonate} disabled={loading} variant="contained" color="primary">
          {loading ? <CircularProgress size={24} /> : "Confirmar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImpersonateModal;
